<template>
  <div class="vcv-settings">
    <vcv-sidebar-navigation :navigation-items="navigationLinks" />

    <div class="vcv-settings__view">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
import { isDomainRu } from '@/_helpers/utils.js';
import VcvSidebarNavigation from '@/components/VcvSidebarNavigation';

export default {
  name: 'VcvSettings',

  components: {
    VcvSidebarNavigation
  },

  computed: {
    ...mapGetters('user', ['isCompanyAdmin']),

    ...mapState('user', { userInfo: 'data' }),

    ...mapGetters('process', ['getProcessName']),

    navigationLinks() {
      return [
        {
          routeName: 'settings-company',
          title: this.$tr('settings.company.title'),
          isDisabled: false
        },
        {
          routeName: 'settings-security',
          title: this.$tr('settings.security.title'),
          isDisabled: !this.isCompanyAdmin
        },
        {
          routeName: 'settings-documents',
          title: this.$tr('billing.company-documents'),
          isDisabled: false,
          feature: 'custom_agreements'
        },
        {
          routeName: 'settings-managers',
          title: this.$tr('settings.users.title'),
          isDisabled: false
        },
        {
          routeName: 'settings-chatbot',
          title: this.$tr('chatbot.chatbot'),
          isDisabled: false,
          feature: 'chatbot'
        },
        {
          routeName: 'settings-statuses',
          title: this.$tr('settings.statuses.title'),
          isDisabled: false
        },
        {
          routeName: 'settings-email',
          title: this.$tr('common.navigation.emailTemplate'),
          isDisabled: false
        },
        {
          routeName: 'settings-smtp',
          title: this.$tr('settings.smtp.title'),
          isDisabled: false
        },
        {
          routeName: 'settings-rates',
          title: this.$tr('common.navigation.rates'),
          isDisabled: false
        },
        {
          routeName: 'settings-log',
          title: this.$tr('common.navigation.log'),
          isDisabled: false,
          feature: 'action_history'
        }
      ];
    }
  },

  created() {
    if (!this.isCompanyAdmin) {
      this.$router.push({ name: 'responses' });
    }

    if (this.getProcessName !== undefined) {
      if (this.getProcessName === PROCESS_NAMES.ALROSA) {
        this.navigationLinks.push({ routeName: 'settings-additional', title: 'Дополнительно' });
      } else if (
        (this.getProcessName === PROCESS_NAMES.MARS && this.userInfo.id === 9529) ||
        (this.getProcessName === PROCESS_NAMES.MARS_MIEP && this.userInfo.id === 9529) ||
        (this.getProcessName === PROCESS_NAMES.MARS_MLEP && this.userInfo.id === 9529)
      ) {
        this.navigationLinks.push({ routeName: 'settings-additional', title: 'Лендинги' });
      }
    }

    if (this.isDomainRu) {
      // Вставляем вкладку Интеграции четвертой в списке в меню настроек компании
      this.navigationLinks.splice(3, 0, {
        routeName: 'settings-integrations',
        title: this.$tr('settings.integrations.title'),
        isDisabled: false
      });
    }
  },

  methods: {
    isDomainRu
  }
};
</script>

<style lang="scss" scoped>
.vcv-settings {
  display: flex;

  &__view {
    background: $background;
    flex: 1;
    padding: 30px;
  }
}
</style>
